<div (focusout)="onFocusOut($event)" (keydown.shift.tab)="$event.preventDefault()">
  <mat-select disableOptionCentering [formControl]="myControl" (selectionChange)="onCategorySelected($event.value)" #categoriesList>
    <mat-option *ngFor="let category of categories" [value]="category">
      {{ category }}
    </mat-option>
  </mat-select>
</div>
